// Borrador de la respuesta de un caso o de un correo (D56): lo que se escribe en el cuadro queda en este navegador, por
// persona y por conversacion, hasta que se envia. Si el envio falla, se recarga la pagina o la sesion se cae, al
// volver esta ahi. Distinto de los borradores de Redactar (lib/borradores.ts): aqui no hay buzon; la CCO se guarda desde D60.
import { readJSON, remove, writeJSON } from './storage';

export type BorradorRespuesta = { texto: string; asunto: string; para: string[]; cc: string[]; cco?: string[]; modo: string; guardado: number };

const clave = (miembroId: string, conversacion: string) => `consola.respuesta.${miembroId}.${conversacion}`;
// Un borrador de hace mas de 30 dias ya no sirve.
const VIDA_MS = 30 * 86_400_000;

export function leerBorradorRespuesta(miembroId: string, conversacion: string, ahora = Date.now()): BorradorRespuesta | null {
  const b = readJSON<BorradorRespuesta | null>(clave(miembroId, conversacion), null);
  if (!b || typeof b.texto !== 'string' || !b.texto.trim()) return null;
  if (ahora - (b.guardado ?? 0) > VIDA_MS) {
    remove(clave(miembroId, conversacion));
    return null;
  }
  return { texto: b.texto, asunto: b.asunto ?? '', para: Array.isArray(b.para) ? b.para : [], cc: Array.isArray(b.cc) ? b.cc : [], cco: Array.isArray(b.cco) ? b.cco : [], modo: b.modo ?? 'responder', guardado: b.guardado };
}

export function guardarBorradorRespuesta(miembroId: string, conversacion: string, b: Omit<BorradorRespuesta, 'guardado'>, ahora = Date.now()) {
  if (!b.texto.trim()) return borrarBorradorRespuesta(miembroId, conversacion);
  writeJSON(clave(miembroId, conversacion), { ...b, guardado: ahora });
}

export const borrarBorradorRespuesta = (miembroId: string, conversacion: string) => remove(clave(miembroId, conversacion));
